/**
 * Medbook
 * Medbook api
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 */
export type TrainingPlanTypeEnum = 'matrix' | 'matrix_courses' | 'matrix_courses_epa' | 'simple' | 'plan_castar' | 'plan_hpb';

export const TrainingPlanTypeEnum = {
    Matrix: 'matrix' as TrainingPlanTypeEnum,
    MatrixCourses: 'matrix_courses' as TrainingPlanTypeEnum,
    MatrixCoursesEpa: 'matrix_courses_epa' as TrainingPlanTypeEnum,
    Simple: 'simple' as TrainingPlanTypeEnum,
    PlanCastar: 'plan_castar' as TrainingPlanTypeEnum,
    PlanHpb: 'plan_hpb' as TrainingPlanTypeEnum
};

